export default __webpack_public_path__ + "static/media/okara-moz-logo-footer.59289131.png";